import { axiosObject } from "../config";

export default function verifyMobileRegistration(form: any) {
  let payload = {
    type: "mobile_number",
    value: "+91" + form.value.user_identity.toLocaleLowerCase(),
    token: form.value.token,
    after_verification: "respond_with_token",
  };

  return new Promise((resolve, reject) => {
    let uri = "access/verify-registration";

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (errors?.response?.data?.message === "AttributeAlreadyExist") {
            form.setErrors({ token: ["Mobile already registered"] });
          } else {
            form.setErrors({ token: [errors.response.data.message] });
          }
        }
        reject(errors);
      });
  });
}
